// extracted by mini-css-extract-plugin
export default {"container":"PairSelect_container__Nt19q"};